import { Outlet } from "react-router-dom"
import { Header } from "./Header"
import { MobileNav } from "./MobileNav"
import { DesktopSidebar } from "./DesktopSidebar"
import { useIsMobile } from "@/hooks/useMediaQuery"
import { cn } from "@/lib/utils"

interface MainLayoutProps {
  children?: React.ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  const isMobile = useIsMobile()

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop: Sidebar layout */}
      {!isMobile && (
        <div className="flex">
          <DesktopSidebar />
          <div className="flex-1 flex flex-col min-h-screen">
            <Header showSettings={false} />
            <main className="flex-1">
              {children ?? <Outlet />}
            </main>
          </div>
        </div>
      )}

      {/* Mobile: Full screen with bottom nav */}
      {isMobile && (
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className={cn("flex-1 pb-16")}>
            {children ?? <Outlet />}
          </main>
          <MobileNav />
        </div>
      )}
    </div>
  )
}
